const constants = {
    updateUploadedBy: (desc, uploadedBy) => {
      if((''+desc).toLowerCase().includes('submitted via online forms')) {
        return 'Online Forms';
      }
      return uploadedBy;
    },
    USER_ACCESS_TOKEN_KEY: 'user_access_token',
    DD_MM_YY: 'DD/MM/YY',
    DD_MM_YYYY: 'DD/MM/YYYY',
    USER: 'USER',
    ROLE: 'ROLE',
    NATA_ROLE_AR: 'AR',
    NATA_ROLE_TA: 'TA',
    NATA_ROLE_TA_ID: 2,
    NATA_ROLE_TA_ADMIN: 'TA_ADMIN',
    NATA_ROLE_CM: 'CM',
    NATA_ROLE_LA: 'LA',
    NATA_ROLE_ADMIN: 'SYSADMIN',
    CURRENT_ROLE : 'CURRENT_ROLE',
    MAX_UPLOAD_SIZE: 150000,
    REMEMBER_ME_FOR_DAYS: 15,
    NICE_MAX_UPLOAD_SIZE: '150MB',
    TIMEZONE: 'Australia/Sydney',
    FILE_EXISTS: "A document by this name has already been submitted. \
        You cannot modify documents once uploaded. \
        Please rename document and try again",
    NATA_CONTACTS: {
      PHONE: "1800 621 666 (free call)",
      PHONE_LINK: "1800621666",
      EMAIL: "portalsupport@nata.com.au",
      ADDRESS: "7 Leeds St, Rhodes NSW 2138",
      ADDRESS_LINK: "https://www.google.com/maps/search/?api=1&query=7+Leeds+St,+Rhodes+NSW+2138",
      WEBSITE: "www.nata.com.au",
      WEBSITE_LINK: "https://www.nata.com.au"
    },
    USER_ROLES :[
      {
        name:'SYSADMIN',
        fullName : 'System Admin'
      },
      {
        name : "AR",
        fullName : "Authorised Representative"
      },
      {
        name : "TA",
        fullName : "Technical Assessor"
      },
      {
        name : "TA_ADMIN",
        fullName : "Technical Assessor Admin"
      },
      {
        name : "LA",
        fullName : "Lead Assessor"
      },
      {
        name : "CM",
        fullName : "Committee Member"
      }
    ],
    USER_STATES: [
      {
        label: "NSW",
        value: "NSW"
      },
      {
        label: "VIC",
        value: "VIC"
      },
      {
        label: "ACT",
        value: "ACT"
      },
      {
        label: "QLD",
        value: "QLD"
      },
      {
        label: "WA",
        value: "WA"
      },
      {
        label: "SA",
        value: "SA"
      },
      {
        label: "NT",
        value: "NT"
      },
      {
        label: "TAS",
        value: "TAS"
      },
      {
        label: "Other",
        value: "Other"
      }
    ],
    SUBSCRIPTION_CATEGORIES: {
      GENERAL: "General",
      ACCREDITATION: "Accreditation Program Updates",
      PUBLICATIONS: "Portal Publications",
      NEWSLETTERS: "NATA Newsletters"
    },
    TA_ADMIN_NOTIFICATION_UN_USED_TAS: 'TA_ADMIN_NOTIFICATION_UN_USED_TAS',
    SYS_ADMIN_NOTIFICATION: 'SYS_ADMIN_NOTIFICATION',
    cacUserOptions: [
      {
        id: 1,
        title: 'Ongoing participation in conformity assessment activities (participation may include supervisory activities)',
        desc: 'For the purposes of this document conformity assessment activities are those that NATA accredited facilities undertake such as testing, inspection, calibration, RMP, PTP, Biobanking, etc.'
      },
      {
        id: 2,
        title: 'Employment (paid or unpaid) (other than direct conformity assessment activities) relevant to my area of expertise e.g. lectures, consultancy etc'
      },
      {
        id: 3,
        title: 'Attendance and or presentation at external seminars, conferences workshops etc'
      },
      {
        id: 4,
        title: 'Publication(s) in peer reviewed journals, industry journals etc'
      },
      {
        id: 5,
        title: 'Membership of professional committees'
      },
      {
        id: 6,
        title: 'Membership of professional societies, peak bodies etc'
      },
      {
        id: 7,
        title: 'Personal certification, accreditation'
      },
      {
        id: 8,
        title: 'Involvement in research projects'
      },
      {
        id: 9,
        title: 'Internal continual development programs e.g. discipline specific training'
      },
      {
        id: 10,
        title: 'Directed self-learning'
      },
      {
        id: 11,
        title: 'Involvement in validation of new methodology'
      },
      {
        id: 12,
        title: 'Writing procedures, technical methods, policies etc relevant to my area of expertise'
      },
      {
        id: 13,
        title: 'Relevant Standards committee participation (e.g. Standards Australia, NPAAC)'
      },
      {
        id: 14,
        title: 'Participation in formal CPD program (e.g. RCPA, RACP, RANZCR)'
      },
      {
        id: 15,
        title: 'Other (Please specify the details below)',
        showTextInput: true,
        associatedText: ''
      },
      {
        id: 16,
        title: 'None of the above'
      }
    ]
};

export default constants;
